import { useState } from "react"
import { useLocation, useNavigate } from "react-router"
import type { ColumnFiltersState, OnChangeFn } from "@tanstack/react-table"

export const useFiltersState = (initialFilters: ColumnFiltersState = []) => {
  const location = useLocation()
  const navigate = useNavigate()

  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>(
    location.state?.filters || initialFilters,
  )

  const onColumnFiltersChange: OnChangeFn<ColumnFiltersState> = (
    updaterOrValue,
  ) => {
    const newFilters =
      typeof updaterOrValue === "function"
        ? updaterOrValue(columnFilters)
        : updaterOrValue

    setColumnFilters(newFilters)

    navigate(".", {
      state: { ...location.state, filters: newFilters },
      replace: true,
    })
  }

  return { columnFilters, onColumnFiltersChange }
}
